/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var People1MinusIcon20Regular = forwardRef('People1MinusIcon20Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5.45 6.506a4.55 4.55 0 1 1 9.1 0 4.55 4.55 0 0 1-9.1 0ZM10 3.456a3.05 3.05 0 1 0 0 6.1 3.05 3.05 0 0 0 0-6.1Z" }),
        React.createElement("path", { d: "M4.35 15.373c-.358.44-.6 1.034-.6 1.873a.75.75 0 0 1-1.5 0c0-1.156.344-2.09.936-2.82.583-.716 1.367-1.187 2.177-1.499 1.601-.617 3.474-.677 4.637-.677a.75.75 0 0 1 0 1.5c-1.151 0-2.778.068-4.098.577-.65.25-1.183.592-1.552 1.046Z" }),
        React.createElement("path", { d: "M11.75 15.25a.75.75 0 0 0 0 1.5h6.5a.75.75 0 0 0 0-1.5h-6.5Z" })));
});
